import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["word"]
  static values = {
    words: Array,
    typingSpeed: { type: Number, default: 100 },
    deletingSpeed: { type: Number, default: 50 },
    pauseDuration: { type: Number, default: 2000 }
  }

  connect() {
    this.wordIndex = 0
    this.charIndex = 0
    this.isDeleting = false
    this.startTyping()
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  startTyping() {
    const currentWord = this.wordsValue[this.wordIndex]
    
    if (this.isDeleting) {
      // Deleting characters
      this.wordTarget.textContent = currentWord.substring(0, this.charIndex - 1)
      this.charIndex--
      
      if (this.charIndex === 0) {
        this.isDeleting = false
        this.wordIndex = (this.wordIndex + 1) % this.wordsValue.length
        this.timeout = setTimeout(() => this.startTyping(), 500)
        return
      }
      
      this.timeout = setTimeout(() => this.startTyping(), this.deletingSpeedValue)
    } else {
      // Typing characters
      this.wordTarget.textContent = currentWord.substring(0, this.charIndex + 1)
      this.charIndex++
      
      if (this.charIndex === currentWord.length) {
        this.isDeleting = true
        this.timeout = setTimeout(() => this.startTyping(), this.pauseDurationValue)
        return
      }
      
      this.timeout = setTimeout(() => this.startTyping(), this.typingSpeedValue)
    }
  }
}


